/**
 * Application Configuration Utilities
 * Centralized helper functions for accessing app config
 */
import appConfig from '@/configs/app-config';

/**
 * Get passenger type breakdown visibility for a product
 * @param {boolean} defaultValue - Default value if config is not found (default: true)
 * @returns {boolean} Whether to show passenger type breakdown
 */
export function getPassengerTypeBreakdownVisibility( defaultValue = true) {
  return appConfig.PRODUCT_CONFIGS?.BUS?.SHOW_PASSENGER_TYPE_BREAKDOWN ?? defaultValue;
}
